<script>
import { useAlert } from 'dashboard/composables';

export default {
  components: {},
  props: {
    inboxId: {
      type: Number,
      required: true,
    },
    timeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      teimosinhaEnabled: false,
      privateMessage: false,
      messageContent: '',
      messageTime: 3600, // Default of 1 hour
      isLoading: false,
      teimosinha_type: 0,
    };
  },
  computed: {
    firstMessagePossibleTimes() {
      return [...this.timeOptions];
    },
  },
  mounted() {},
  methods: {
    async createTeimosinhaMessage() {
      const payload = {
        inboxId: this.inboxId,
        teimosinhaSettings: {
          content: this.messageContent,
          time_to_send_seconds: this.messageTime,
          private_message: this.privateMessage,
          teimosinha_type: this.teimosinha_type,
        },
      };
      try {
        this.isLoading = true;
        await this.$store.dispatch('inboxes/createTeimosinhaMessage', payload);
        this.isLoading = false;
        this.onClose();
        useAlert(
          this.$t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        useAlert(
          this.$t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.API.ERROR_MESSAGE')
        );
        this.isLoading = false;
      }
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div class="h-auto overflow-auto flex flex-col">
    <woot-modal-header
      :header-title="$t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.HEADER')"
    />
    <form class="mx-0 flex flex-wrap" @submit.prevent="createTeimosinhaMessage">
      <!-- TIME WITHOUT RESPONSE -->
      <div>
        <label>
          {{
            $t(
              'INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.TIME_WITHOUT_RESPONSE.HEADER'
            )
          }}
        </label>
        <span class="text-xs">
          {{
            $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.TIME_WITHOUT_RESPONSE.INFO')
          }}
        </span>
        <select v-model="messageTime">
          <option
            v-for="time in timeOptions"
            :key="time.key"
            :value="time.key"
            :disabled="time.disabled"
          >
            {{ time.name }}
          </option>
        </select>
      </div>
      <!-- PRIVATE MESSAGE -->
      <div>
        <label>
          {{ $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.PRIVATE_MESSAGE.HEADER') }}
        </label>
        <span class="text-xs">
          {{ $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.PRIVATE_MESSAGE.INFO') }}
        </span>
        <select v-model="privateMessage">
          <option key="true" :value="true">
            {{ $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.PRIVATE_MESSAGE.YES') }}
          </option>
          <option key="false" :value="false">
            {{ $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.PRIVATE_MESSAGE.NO') }}
          </option>
        </select>
      </div>
      <!-- MESSAGE CONTENT -->
      <woot-input
        v-model.trim="messageContent"
        v-tooltip.bottom="messageContent"
        class="w-full"
        :label="$t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.MESSAGE_CONTENT.HEADER')"
        :placeholder="
          $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.MESSAGE_CONTENT.PLACE_HOLDER')
        "
      />

      <div class="flex justify-end items-center py-2 px-0 gap-2 w-full">
        <woot-button :is-loading="isLoading">
          {{ $t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.BUTTONS.CREATE') }}
        </woot-button>
        <woot-button
          :is-loading="isLoading"
          class="button clear"
          @click.prevent="onClose"
        >
          {{ $t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.BUTTONS.CANCEL') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>
